import React from "react";
import "./NewsletterSection.css";

// Import required components
import { Heading, Newsletter } from "../../../components";



const NewsletterSection = () => {
  return (
    <section className="newsletter-subscribe">
      <div className="content">

          <Heading title={"Subscribe To Our Newsletter"} linear /> {/* Section heading with linear style */}
          <p>Stay in the loop with the latest events, speaker announcements, networking opportunities, and exclusive offers. Join our community and be the first to know!</p>

          <Newsletter variant='default' idPrefix='1' /> {/* Newsletter subscription form */}

      </div>
    </section>
  );
};

export default NewsletterSection;